<template>
  <div v-if="activeEffect" class="seasonal-effect" :class="`seasonal-effect--${activeEffect}`" aria-hidden="true">
    <span
      v-for="particle in particles"
      :key="particle.id"
      class="seasonal-effect__particle"
      :style="particle.style"
    >
      <img
        v-if="particle.image"
        class="seasonal-effect__falling-image"
        :src="particle.image"
        alt=""
      />
      <template v-else>{{ particle.symbol }}</template>
    </span>
  </div>
</template>

<script>
const SYMBOLS = {
  love: ["♥", "♥", "♡"],
  halloween: ["🕷", "🎃", "💀", "⚰", "👻"],
  christmas: ["❄", "❅", "✦", "🎅"],
  newyear: ["✦", "✧", "★"]
};

export default {
  name: "SeasonalEffect",
  props: {
    effect: { type: String, default: "none" }
  },
  computed: {
    activeEffect() {
      return Object.prototype.hasOwnProperty.call(SYMBOLS, this.effect) ? this.effect : "";
    },
    particles() {
      if (!this.activeEffect) return [];
      return Array.from({ length: 18 }, (_, id) => ({
        id,
        image: this.activeEffect === "halloween" && id % 7 === 6
          ? "/images/halloween-falling.svg"
          : "",
        symbol: SYMBOLS[this.activeEffect][id % SYMBOLS[this.activeEffect].length],
        style: {
          left: `${(id * 47 + 13) % 100}%`,
          animationDelay: `${-((id * 7) % 18)}s`,
          animationDuration: `${12 + (id % 7) * 2}s`,
          fontSize: `${14 + (id % 4) * 5}px`,
          opacity: 0.35 + (id % 4) * 0.12
        }
      }));
    }
  }
};
</script>

<style scoped>
.seasonal-effect {
  position: fixed;
  inset: 0;
  z-index: 10;
  overflow: hidden;
  pointer-events: none;
  user-select: none;
}
.seasonal-effect__particle {
  position: absolute;
  top: -10vh;
  display: block;
  line-height: 1;
  animation: seasonal-fall linear infinite;
  will-change: transform;
}
.seasonal-effect__falling-image {
  display: block;
  width: 1.5em;
  height: auto;
  filter: invert(1) drop-shadow(0 0 3px rgba(255, 123, 28, 0.75));
}
.seasonal-effect--love { color: #e83872; }
.seasonal-effect--halloween { color: #e87916; }
.seasonal-effect--christmas { color: #b9e9ff; }
.seasonal-effect--newyear { color: #eac45e; }
@keyframes seasonal-fall {
  from { transform: translate3d(0, -10vh, 0) rotate(0deg); }
  to { transform: translate3d(45px, 115vh, 0) rotate(300deg); }
}
@media (prefers-reduced-motion: reduce) {
  .seasonal-effect { display: none; }
}
</style>
